import { createApp } from "vue";
import VueScrollTo from "vue-scrollto";
import TicketShop from "./components/TicketShop.vue";
import store from "./helper/store";
import lang from "./helper/lang";
import Vueform from '@vueform/vueform'
import formatMoney from "./helper/formatMoney";
import vueformConfig from './vueform.config'
import CookieConsentVue from './CookieConsentVue.js'


globalThis.__VUE_OPTIONS_API__ = true;
globalThis.__VUE_PROD_DEVTOOLS__ = false;
globalThis.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

window.initTicketShop = function(elementId, settings) {
    const app = createApp(TicketShop, settings);
    app.use(Vueform, vueformConfig)
    app.use(VueScrollTo);
    app.use(lang)
    app.use(store)
    app.use(CookieConsentVue)
    app.config.globalProperties.$filters = {
        currency(number) {
            const options = {
                symbol: ' €',
                fractionCount: '2',
                thousandsSeparator: '.',
                fractionSeparator: ','
            }
            return formatMoney (number, options)
        }
    }
    if (typeof window.initSentry !== "undefined") {
        window.initSentry(app);
    }
    app.mount(elementId);
}
